// extracted by mini-css-extract-plugin
module.exports = {"search":"style_search__3PpeZ","search_btn":"style_search_btn__1kdtC","clear_btn":"style_clear_btn__1o2xS"};